


import React, { useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import announcementServices from "../../services/announcementServices";
import ImageWithFallback from "../ImageWithFallback";
import sliderServices from "../../services/sliderServices";

const AnnouncementSection = styled(Box)({
    padding: "20px 0",
    backgroundColor: "#f5f5f5",
});

const SliderContainer = styled(Box)({
    position: "relative",
    "& .swiper": {
        width: "100%",
        height: "80vh",
    },
    "& .swiper-slide": {
        position: "relative",
    },
    "& .swiper-button-next, & .swiper-button-prev": {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        color: "#fff",
        "&::after": {
            fontSize: "20px",
        },
    },
    "& .swiper-pagination-bullet": {
        backgroundColor: "#fff",
        opacity: 0.7,
        "&-active": {
            opacity: 1,
        },
    },
});

const SlideImage = styled("img")({
    width: "100%",
    height: "100%",
    objectFit: "cover",
});

const SlideContent = styled(Box)({
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "20px",
    background: "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0))",
    color: "#fff",
});

const SlideTitle = styled(Typography)({
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "10px",
});

const getFileType = (url) => url?.split(".").pop().toLowerCase();

const Slider = () => {
    const [data, setData] = useState([]);

    const getData = async () => {
        try {
            const res = await sliderServices.get();
            console.log("---res---", res);
            setData(res?.data?.data || []);
        } catch (error) {
            console.error("Failed to fetch slider data:", error);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <AnnouncementSection>
            <SliderContainer>
                {data.length > 0 && (
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={0}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        loop={true}
                    >
                        {data.map((item) => (
                            <SwiperSlide key={item.id}>
                                {getFileType(item?.images[0]?.path) === "pdf" ? (
                                    <SlideImage
                                        onClick={() => window.open(item?.images[0]?.path, "_blank")}
                                        src="/pdf.png"
                                        style={{ objectFit: "contain" }}
                                        alt={item.title}
                                    />
                                ) : (
                                    <ImageWithFallback
                                        path={item?.images[0]?.path}
                                        alt={item.title}
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                )}
                                <SlideContent>
                                    <SlideTitle variant="h3">{item.caption}</SlideTitle>
                                </SlideContent>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </SliderContainer>
        </AnnouncementSection>
    );
};

export default Slider;
